export default [{
  name: 'terminal',
  path: 'terminal',
  component: () => import('./Terminal.vue'),
  meta: {
    title: '终端设置'
  }
}]



// WEBPACK FOOTER //
// ./src/router/terminal/index.js